module.exports = __webpack_public_path__ + "img/school7.13ca1e7e.png";